
// import "./../../node_modules/bulma/css/bulma.css";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Component, Vue } from "vue-property-decorator";
import HazardList from "../components/HazardList.vue";
@Component({
  components: {
    HazardList
  }
})
export default class WorkMate extends Vue {}
